import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-material-master',
  templateUrl: './material-master.component.html',
  styleUrl: './material-master.component.css'
})
export class MaterialMasterComponent {

  machineList:any[]=[];
  

  displayedColumns: string[] = ['srNo', 
  // "equipment_id",
  "equipment_code",
  "equipment_name",
  "category",
  // "capacity",
  // "specification",
  "is_active",
  "action"
  ];
  dataSource = new MatTableDataSource([]);
  searchKeyword = "";
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  constructor(
    private readonly apiService: ApiService,
    private router: Router,
    private toastrMsgService: ToastrService){
    
  }
  
  ngAfterViewInit() {
    this.fetchData();
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  onStatusChange(event: any) {
    // const status = event.value;
    const status = (event.target as HTMLSelectElement).value;

    this.dataSource.data = status
      ? this.machineList.filter(machine => machine.status === status)
      : this.machineList as any;
  }


  fetchData() {
    
    this.apiService.getMaterialsMaster().subscribe({
      next: (res:any) => {        console.log(res);
         
      this.dataSource.data = res},
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
       },
      complete: () => console.log('Observable complete'),
    });
  }}